'use client'

import { Checkbox as CheckboxPrimitive } from '@base-ui/react/checkbox'
import { cn } from '@/lib/utils'

type CheckboxProps = Omit<CheckboxPrimitive.Root.Props, 'className'> & {
    className?: string
}

/*
 * GoodUnited / Checkbox. Figma: 10 / Components / Checkbox.
 * 20px, 4px corners. Unchecked uses Colors/input, checked uses Colors/action/primary.
 */
function Checkbox({ className, ...props }: CheckboxProps) {
    return (
        <CheckboxPrimitive.Root
            data-slot='checkbox'
            className={cn(
                'peer relative inline-flex size-5 shrink-0 cursor-pointer items-center justify-center rounded-sm border border-input-border bg-input-background text-action-primary-foreground transition-colors outline-none hover:border-input-border-hover focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-focus data-checked:border-border-subtle data-checked:bg-action-primary data-disabled:cursor-not-allowed data-disabled:opacity-50',
                className
            )}
            {...props}
        >
            <CheckboxPrimitive.Indicator
                data-slot='checkbox-indicator'
                className='flex items-center justify-center'
            >
                <svg width='10' height='7' viewBox='0 0 10 7' fill='none' aria-hidden='true'>
                    <path d='M1 3.5L3.75 6L9 1' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' />
                </svg>
            </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
    )
}

export { Checkbox }
